import React, { ChangeEvent, Component, useContext, useState } from "react";
import "./ShopifyPushInventoryModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IShopifyPushInventoryDTO from "../../../../models/DTO/IShopifyPushInventoryDTO";
import IShopify from "../../../../models/IShopify";
import SupplierContext from "../../../../contexts/SupplierContext";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    startProcessing: (options: Partial<IShopifyPushInventoryDTO>) => void;
};

export const ShopifyPushInventoryModal: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const [shopGuid, setShopGuid] = useState<string>();
    const [shopifyShop, setShopifyShop] = useState<IShopify | undefined>();
    const [allShops, setAllShops] = useState(true);

    const closeModal = () => {
        props.closeModalFn();
    };

    const selectShop = (shopModel: IShopify) => {
        const guid = shopModel.guid;

        setShopGuid(guid);
        setShopifyShop(shopModel);
    };

    const start = () => {
        const payload: Partial<IShopifyPushInventoryDTO> = {};

        if (shopGuid) {
            payload.shopGuid = shopGuid;
        }

        props.startProcessing(payload);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        setAllShops(value);
    };

    return (
        <div className={"ShopifyPushInventoryModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-box"} title={"push_inventory"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwCheckbox label={"all_shops"} fn={handleChange} checked={allShops} falsyVal={false} truthyVal={true} />
                </div>
                <div>
                    <OwSelectOption
                        name={"shop"}
                        fn={selectShop}
                        options={supplierModel.Shopifies}
                        emitObject={true}
                        titleProp={"shopify_shop"}
                        valueProp={"guid"}
                        isDisabled={allShops}
                    />
                </div>

                <div className={"mb-2 mt-2"}>
                    {shopifyShop ? (
                        <div>
                            <div>
                                <OwLabel title={"catalog"} isBold={true} className={"me-2"} postText={":"} />
                                {shopifyShop.Catalog?.name}
                            </div>
                            <div>
                                <OwLabel title={"price_group"} isBold={true} className={"me-2"} postText={":"} />
                                {shopifyShop.Price_Group?.value}
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className={"mt-2"}>
                    <OwButton title={"start"} fn={start} disabled={!allShops && !shopGuid} />
                </div>
            </div>
        </div>
    );
};
